import React from 'react'
import './filter.scss'
import Dropdown from '../../common/dropdown-v2/dropdown'

import SchoolApi from '../../../apis/school'
import MasterDataApi from '../../../apis/master-data'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'bootstrap/dist/css/bootstrap.css'
class FilterComponent extends React.Component {
  state = {
    showFilters: true,

    baslineDropdownItems: [
      { title: 'Completed', value: 'COMPLETED' },
      { title: 'Not Completed', value: 'NOT_COMPLETED' },
    ],

    qualifiedDropdownItems: [
      { title: 'Yes', value: 'true' },
      { title: 'No', value: 'false' },
    ]
  }

  componentDidMount () {}

  reloadDropdown () {
    this.setState({ reloadDropdown: true }, () => {
      this.setState({ reloadDropdown: false })
    })
  }

  refreshPage () {
    this.setState({ reload: true }, () => this.setState({ reload: false }))
  }

  toggleFilters = () => {
    this.setState({ showFilters: !this.state.showFilters })
  }

  onSelectDropDown = (option, key) => {
    const {screen} = this.props
    // let toBeEmptiedKey =
    //     key === 'finishlineStatus'
    //       ? 'qualified'
    //       :'finishlineStatus'

    // this.setState({
    //   [toBeEmptiedKey]: '',
    // }, _ => {
      this.refreshPage()
      this.setState({ [key]: option?.value, [`${key}Object`]: option })
    // })
  }

  onClickGo = () => {
    let payload = {}
    if (this.state.baselineStatus) {
      payload.baselineStatus = this.state.baselineStatus
    }
    if (this.state.qualified) {
      payload.qualified = this.state.qualified
    }
    if (this.state.finishlineStatus) {
      payload.finishlineStatus = this.state.finishlineStatus
    }
    if (this.props.delegate.onFilterGo) {
      this.props.delegate.onFilterGo(payload)
    }
  }

  clearFilter = () => {
    this.setState(
      {
        qualified: '',
        baselineStatus: '',
        finishlineStatus: ''
      },
      () => {
        this.refreshPage()
        if (this.props.delegate.onFilterGo) {
          this.props.delegate.onFilterGo()
        }
      }
    )
  }

  refreshPage () {
    this.setState({ reload: true }, () => this.setState({ reload: false }))
  }

  onChangeHandler (event, key) {
    let value = event.target.value
    this.setState({ [key]: value })
  }

  render () {
    return (
      <div className='student-filter'>
        <div className='filter-header'>
          <div className='d-inline' onClick={this.toggleFilters}>
            <div className='filter-title d-inline'>{'Filters'}</div>
            <div className='d-inline'>
              <i
                class={
                  this.state.showFilters
                    ? 'filter-arrow up'
                    : 'filter-arrow down'
                }
              ></i>
            </div>
          </div>
        </div>
        {!this.state.reload ? (
          <div
            className={
              this.state.showFilters
                ? 'filter-content'
                : 'filter-content d-none'
            }
          >
            <div className='row'>
              
              <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                <div className='filter-input-label'>Baseline Assessment Status</div>
                <div>
                  {!this.state.reloadDropdown ? (
                    <Dropdown
                      key='status'
                      placeholder='Select Status'
                      options={this.state.baslineDropdownItems}
                      onSelect={option =>
                        this.onSelectDropDown(option, 'baselineStatus')
                      }
                      text={'title'}
                      value={this.state.baselineStatus}
                    ></Dropdown>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                <div className='filter-input-label'>Qualified</div>
                <div>
                  {!this.state.reloadDropdown ? (
                    <Dropdown
                      key='status'
                      placeholder='Select Qualififed'
                      options={this.state.qualifiedDropdownItems}
                      onSelect={option =>
                        this.onSelectDropDown(option, 'qualified')
                      }
                      text={'title'}
                      value={this.state.qualified}
                    ></Dropdown>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                <div className='filter-input-label'>Finishline Assessment Status</div>
                <div>
                  {!this.state.reloadDropdown ? (
                    <Dropdown
                      key='status'
                      placeholder='Select Status'
                      options={this.state.baslineDropdownItems}
                      onSelect={option =>
                        this.onSelectDropDown(option, 'finishlineStatus')
                      }
                      text={'title'}
                      value={this.state.finishlineStatus}
                    ></Dropdown>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className='col ml-2 my-auto pt-4'>
                <div className='filter-button  d-inline-block'>
                  <button
                    className={`cw-button`}
                    onClick={this.onClickGo.bind(this)}
                  >
                    {'GO'}
                  </button>
                </div>
                <div className='filter-button ml-3 d-inline-block'>
                  <button
                    className={`cw-button clear-btn`}
                    onClick={this.clearFilter.bind(this)}
                  >
                    {'CLEAR'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}

export default FilterComponent
